import $ from 'jquery';

$(function () {
  var otherRow = function (title, data) {
    return $('<div>', {
      class: 'caption',
      text: title + data,
      title: data,
    });
  };

  var otherRows = function (data, type, row) {
    var rows = [];
    if (data) {
      rows.push(otherRow('External: ', data));
    }
    rows.push(otherRow('UUID: ', row.uuid));
    if (row.brand_signifier) {
      rows.push(otherRow('Brand: ', row.brand_signifier));
    }
    if (row.language) {
      rows.push(otherRow('Language: ', row.language));
    }
    if (row.country) {
      rows.push(otherRow('Country: ', row.country));
    }
    if (row.type) {
      rows.push(otherRow('Type: ', row.type));
    }
    if (row.initial_feedback_request_id) {
      rows.push(
        otherRow(
          'Initial Feedback Request Id: ',
          row.initial_feedback_request_id,
        ),
      );
    }
    return rows
      .map(function (e) {
        return e.prop('outerHTML');
      })
      .join('');
  };

  var setupTable = function (table, records) {
    var currentTable = $(table);
    var perPage = currentTable.data('perpage') || 100;
    var showReason = currentTable.hasClass('js-data-table-invalid');

    var csvOnlyKeyTitles;
    csvOnlyKeyTitles = {
      uuid: 'request_id',
      created_at: 'request_sent_at',
      ext_interaction_id: null,
      external_url: null,
      channel: null,
      request_tags: 'tags',
      brand_signifier: 'brand',
      customer_name: null,
      customer_email: 'request_sent_to',
      employee_first_name: null,
      employee_last_name: null,
      employee_email: null,
      custom_employee_id: 'employee_custom_id',
      language: null,
      country: null,
      type: null,
      initial_feedback_request_id: null,
    };
    if (showReason) {
      csvOnlyKeyTitles.reason = null;
    }

    var exportColumns = Object.keys(csvOnlyKeyTitles).map(function (key) {
      return key + ':name';
    });

    var csvOnlyColumns = Object.keys(csvOnlyKeyTitles).map(function (key) {
      var title = csvOnlyKeyTitles[key];
      if (!title) {
        title = key;
      }
      return {
        title: title,
        name: key,
        data: key,
        visible: false,
      };
    });

    currentTable.DataTable({
      data: records,
      deferRender: true,
      pageLength: perPage,
      columns: [
        {
          title: 'Date',
          data: 'created_at',
          render: function (data, type, row) {
            return (
              '<div class="headline">' +
              data +
              '</div><div class="caption error">' +
              (row.reason ? row.reason : '') +
              '</div>'
            );
          },
          width: '20%',
          export: true,
        },
        {
          title: 'Employee',
          data: 'employee_name',
          render: function (data, type, row) {
            var employeeName = data
              ? '<div class="headline">' + data + '</div>'
              : '';
            var employeeCaption =
              row.employee_email +
              (row.custom_employee_id ? '; ' + row.custom_employee_id : '');
            return (
              employeeName +
              '<div class="caption" title="' +
              employeeCaption +
              '">' +
              employeeCaption +
              '</div>'
            );
          },
          width: '20%',
        },
        {
          title: 'Customer',
          data: 'customer_name',
          render: function (data, type, row) {
            return (
              '<div class="headline">' +
              data +
              '</div><div class="caption" title="' +
              row.customer_email +
              '">' +
              row.customer_email +
              '</div>'
            );
          },
          width: '20%',
        },
        {
          title: 'Channel',
          data: function (row) {
            return row.channel || (row.body && row.body.channel) || '';
          },
          width: '11%',
        },
        {
          title: 'Do Not Send',
          data: 'do_not_send',
          width: '11%',
        },
        {
          title: 'Other',
          data: 'ext_interaction_id',
          render: function (data, type, row) {
            return otherRows(data, type, row);
          },
          width: '18%',
        },
      ].concat(csvOnlyColumns),
      autoWidth: false,
      buttons: [
        {
          extend: 'csv',
          text: 'Download',
          className: 'btn-secondary',
          exportOptions: {
            columns: exportColumns,
          },
        },
      ],
      order: [[0, 'desc']],
      language: {
        paginate: {
          previous: ' ',
          next: ' ',
        },
        lengthMenu: 'Per page: _MENU_',
        searchPlaceholder: 'Search uuid, channel, etc.',
      },
      dom:
        '<"pull-right dataTablesFilterAndLength"flB>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row"<"col-sm-5"><"col-sm-7"p>>',
      stateSave: true,
    });
  };

  var fetchData = function ($table) {
    if (
      $.fn.dataTable.isDataTable($table) &&
      !$table.dataTable().data().length
    ) {
      return;
    }
    var key = $table.data('keyName');
    $.ajax({
      type: 'get',
      dataType: 'json',
      url: window.location.pathname + '/' + key,
      success: function (data) {
        $('.js-' + key + '-count span').text('(' + data[key + '_count'] + ')');
        setupTable($table, data[key]);
      },
      complete: function () {
        $('.js-request-status-loading-indicator').addClass('hidden');
      },
      error: function () {
        $('.js-request-status-error').removeClass('hidden');
      },
    });
  };

  if ($('.js-data-table-invalid, .js-data-table-test').length) {
    $('.js-test_requests-count').click(function () {
      fetchData($('.js-data-table-test'));
    });
    $('.js-invalid_manual_requests-count').click(function () {
      fetchData($('.js-data-table-invalid_manual'));
    });
    fetchData($('.js-data-table-invalid'));
  }
});
